// @ts-nocheck
import SceneLayerMulti from "./multi";
import SceneGeometrySmartMulti from "~/scene/geometry/smartmulti";
import SceneCoords from "~/scene/common/coords";
import Scene from "~/scene";
import { store } from "~/state/store";

export default class SceneLayerMapyLookup extends SceneLayerMulti {
	/**
	 * Vytvoreni multi vrstvy pro lookup a dalsi.
	 *
	 * @param  {String|Number} [id] Volitelne ID
	 */
	constructor(scene, itemId, id) {
		super(scene, itemId, id);

		this._markerLayers = {}; /* prevod ID na vrstvu */
		this._geometryLayers = {}; /* prevod ID na vrstvu */

		this._filters = {
			marker: [],
			geometry: [],
		};

		this._oldMarkers = {}; /* ID vrstvy => pole entit. Tyto znacky prosime vyhodit. */
		this._newData = { /* ID vrstvy => pole entit. Tyto znacky a geometrie prosime vyrobit. */
			marker: {},
			geometry: {},
		};

		this._prevZoom = 0;
	}

	/**
	 * Informace ohledne entity ve scene.
	 *
	 * @return {Object}
	 */
	// eslint-disable-next-line class-methods-use-this
	get featureInfo() {
		return {
			name: "SceneLayerMapyLookup",
			type: "layer",
		};
	}

	/**
	 * Souhrn vsech dat, ktere vyuziva visualiser pri vytvoreni.
	 *
	 * @return {Object}
	 */
	getCreateData() {
		const rd = super.getCreateData();

		rd.filters = this._filters;

		return rd;
	}

	getFilters() {
		return this._filters;
	}

	/**
	 * Pridani vrstvy pro markery.
	 *
	 * @return {SceneLayerMarker}
	 */
	addMarkerLayer(...args) {
		const addLayer = this._addLayer("marker", args[0], args[1], args[2]);

		this._onChange(this._scene.featureEvent("layerMapyLookupAddMarkerLayer", true, true), args);

		return addLayer;
	}

	/**
	 * Pridani vrstvy pro geometrie.
	 *
	 * @return {SceneLayerGeometry}
	 */
	addGeometryLayer(...args) {
		const addLayer = this._addLayer("geometry", args[0], args[1], args[2]);

		this._onChange(this._scene.featureEvent("layerMapyLookupAddGeometryLayer", true, true), args);

		return addLayer;
	}

	/**
	 * Odstraneni vsech polozek z vrstev.
	 */
	removeAll() {
		this._layers.forEach(layer => {
			layer.removeAll("poi");
		});
	}

	/**
	 * Napln vrstvy daty.
	 */
	fillFromData(...args) {
		const { zoom } = store.getState().map;
		let layer = null;

		// pokud mame jiny zoom, nejprve vsechno odebereme, aby doslo k animaci ikon pri vlozeni do mapy
		if (this._prevZoom !== zoom) {
			this.removeAll();
		}

		for (const layerId in this._markerLayers) {
			if (layerId in this._markerLayers) {
				this._oldMarkers[layerId] = this._markerLayers[layerId].getMarkers("poi");
				this._newData.marker[layerId] = [];
			}
		}

		for (const layerId in this._geometryLayers) {
			if (layerId in this._geometryLayers) {
				this._newData.geometry[layerId] = [];
			}
		}

		const dataSets = args[0] instanceof Array ? args[0] : [args[0]];

		for (let index = 0; index < dataSets.length; index++) {
			const dataSet = dataSets[index];

			if (!dataSet.nodeType) {
				this._parseData(dataSet);
			}
		} // pro vsechny sady dat

		// zahodit stare znacky
		for (const layerId in this._oldMarkers) {
			if (layerId in this._oldMarkers) {
				const markersToRemove = [];

				layer = this._markerLayers[layerId];

				// pokud mame marker i v novem lookupu, tak neodebirame, protoze pouzivame jiz vytvoreny marker
				for (let index = 0; index < (this._oldMarkers[layerId] || []).length; index++) {
					if (this._newData.marker[layerId].indexOf(this._oldMarkers[layerId][index]) === -1) {
						markersToRemove.push(this._oldMarkers[layerId][index]);
					}
				}

				layer.removeMarker(markersToRemove, true);
			}
		}

		// zahodit stare geometrie
		for (const layerId in this._geometryLayers) {
			if (layerId in this._geometryLayers) {
				this._geometryLayers[layerId].removeAll();
			}
		}

		// projit nove znacky
		for (const layerId in this._newData.marker) {
			if (layerId in this._newData.marker) {
				const newMarkers = [];

				layer = this._markerLayers[layerId];

				// zkontrolovat, zda poi uz v mape neni
				for (let index = 0; index < this._newData.marker[layerId].length; index++) {
					if (this._oldMarkers[layerId].indexOf(this._newData.marker[layerId][index]) === -1) {
						newMarkers.push(this._newData.marker[layerId][index]);
					}
				}

				layer.addMarker(newMarkers);
			}
		}

		layer.redraw(true);

		// projit nove geometrie
		for (const layerId in this._newData.geometry) {
			if (layerId in this._newData.geometry) {
				layer = this._geometryLayers[layerId];
				const geometries = this._newData.geometry[layerId];

				geometries.sort((first, second) => {
					const ap = first.isPoint();
					const bp = second.isPoint();

					if (ap === bp) {
						return 0;
					}

					return ap ? 1 : -1;
				});

				for (let index=0; index < geometries.length; index++) {
					if (geometries[index] instanceof SceneGeometrySmartMulti) {
						layer.addSmartGeometry(geometries[index]);
					} else {
						layer.addGeometry(geometries[index]);
					}
				}
			}
		}

		layer.redraw();

		// ulozime si aktualni zoom pro dalsi lookup
		this._prevZoom = zoom;

		this._onChange(this._scene.featureEvent("fillFromData", true, true), args);
	}

	/**
	 * Prekresleni vrstev.
	 */
	redraw() {
		this._layers.forEach(layer => {
			layer.redraw(false);
		});
	}

	/**
	 * Pridani vrstvy pro markery.
	 *
	 * @param {SceneLayer} layer
	 * @return {SceneLayer}
	 */
	addLayer(layer) {
		// vytvorime vrstvu -> pokud jiz je vytvorena, tak preskocime
		this._onChange(this._scene.featureEvent("createLayer", true), [layer]);

		this._layers.push(layer);
		layer.sceneOwner = this;

		if (this.appended) {
			layer.appended = true;
		}
		if (this._active) {
			layer.enable();
		}

		// doslo by k dvojitemu vytvoreni
		//this._onChange(this._scene.featureEvent("layerMultiAddLayer", true, true), arguments);
	}

	/**
	 * Pridani vrstvy.
	 *
	 * @param {String} type Typ vrstvy
	 * @param {SceneLayer} layer
	 * @param {Array} sources Ktere zdroje bude obsluhovat?
	 * @param {Array} types Seznam typu
	 * @private
	 */
	_addLayer(type, layer, sources, types) {
		this[`_${type}Layers`][layer.getId()] = layer;
		this._filters[type].push({
			sources: sources,
			types: types,
			layerId: layer.getId(),
			layer: layer,
		});

		this.addLayer(layer);
	}

	/**
	 * Parsovani dat.
	 *
	 * @param  {Object} data
	 */
	_parseData(data) {
		const pois = data.poi || [];

		for (let index = 0; index < pois.length; index++) {
			try {
				const poi = pois[index];
				const source = poi.source;
				const isGeom = poi.geom;
				const layerId = this._findLayer(isGeom ? "geometry" : "marker", source, poi.typeId);
				const markerTest = isGeom ? true : !this._checkMarker(source + poi.id, layerId);

				if (layerId && markerTest) {
					if (poi.geom) {
						// naplnime interne daty

						/*
							novy traffic a bile stopy se zpracovavaji v samostatnych vrstvach
							2010 - traffic
							1046 - bila stopa
							1047 - bila stopa
							1048 - bila stopa
						*/
						if ([2010, 1046, 1047, 1048].indexOf(poi.typeId) !== -1) {
							continue;
						}

						let geom = null;

						if (poi.source === "rout") {
							geom = this._scene.createGeometryTraffic(poi);
						} else if (poi.geom.type === "polygon" || poi.geom.type === "multipolygon" || poi.geom.type === "path") {
							geom = this._scene.createGeometryMulti(poi, {
								clickable: true,
								..."minDist" in poi.geom ? { minDist: poi.geom.minDist } : {},
							});
						} else {
							geom = this._scene.createGeometrySmartMulti(poi, { clickable: true });
						}

						this._newData.geometry[layerId].push(geom);

						if (poi.closedRoute) {
							if (poi.multiMark && "data" in poi.multiMark) {
								this._handleMultiMarker(poi);
							} else {
								const marker = this._scene.createMarkerMapyWindyFromData(poi);

								this._newData.marker[this._findLayer("marker", source, poi.typeId)].push(marker);
							}
						}
					} else if (poi.multiMark && "data" in poi.multiMark) {
						this._handleMultiMarker(poi);
					} else {
						let marker = null;

						// zkontrolovat, zda dany marker uz nemame v mape, pokud ano, nebudeme ho pridavat, ale pouzijeme ten co mame
						for (let indx = 0; indx < (this._oldMarkers[layerId] || []).length; indx++) {
							const oMarker = this._oldMarkers[layerId][indx];
							const oPoi = "getPOI" in oMarker ? oMarker.getPOI() : null;

							if (oPoi && oPoi.source === poi.source && oPoi.id === poi.id) { // poi
								marker = oMarker;
								break;
							} else if (oMarker.getSource() === poi.source && oMarker.getPlainId() === poi.source) { // fotopoi
								marker = oMarker;
								break;
							}
						}

						if (!marker) {
							if (poi.source === "foto" || poi.source === "ffoto") {
								marker = this._scene.createMarkerFotoFromData(poi);
							} else if (poi.source === "wcam") {
								marker = this._scene.createMarkerWindyWebcamFromData(poi);
							} else {
								marker = this._scene.createMarkerMapyWindyFromData(poi);
							}
						}

						this._newData.marker[layerId] && this._newData.marker[layerId].push(marker);
					}
				}
			} catch (error) {
				// eslint-disable-next-line no-console
				console.log(`Chyba dat poie, source: ${pois[index].source}, id: ${pois[index].id}`, error);
			}
		}
	}

	_handleMultiMarker(poi) {
		Mapy.Util.filterCoords(poi.multiMark.data.map(mark => {
			const coords = SMap.Coords.stringToCoords(mark)[0].toWGS84();

			return new SceneCoords(Scene, coords[0], coords[1]);
		}), {
			diameter: 29,
		}).forEach((coor, key) => {
			const markerPoiLayerID = this._findLayer("marker", poi.source, poi.typeId);
			const coords = coor.toWGS84();
			let marker = null;

			// zkontrolovat, zda dany  multimarker uz nemame v mape, pokud ano, nebudeme ho pridavat, ale pouzijeme ten co mame
			for (let indx = 0; indx < (this._oldMarkers[markerPoiLayerID] || []).length; indx++) {
				const oMarker = this._oldMarkers[markerPoiLayerID][indx];
				const oPoi = "getPOI" in oMarker ? oMarker.getPOI() : null;

				if (oPoi && oPoi.source === poi.source && oPoi.id === poi.id && oPoi.key === key) { // poi
					marker = oMarker;
					break;
				}
			}

			if (!marker) {
				marker = this._scene.createMarkerMapyWindyFromData({
					desc: {
						text: "",
					},
					description: "",
					extend: poi.extend,
					geomInLookup: false,
					mark: {
						lat: coords[1],
						lon: coords[0],
					},
					multiMark: {},
					source: poi.source,
					title: poi.title,
					id: poi.id, //`${poi.id}-${key}`,
					key,
					typeId: poi.typeId,
					zoom: 0,
					zoomMax: 0,
					noReposition: true,
					future: poi.future,
					past: poi.past,
				});
			}

			this._newData.marker[this._findLayer("marker", poi.source, poi.typeId)].push(marker);
		});
	}

	/**
	 * Najdi vrstvu.
	 *
	 * @param  {String} layerType Typ vrstvy
	 * @param  {String} source Zdroj
	 * @param  {String} type Typ
	 */
	_findLayer(layerType, source, type) {
		const filters = this._filters[layerType];

		for (let index = 0; index < filters.length; index++) {
			const filter = filters[index];
			const sourceOK = !filter.sources || filter.sources.indexOf(source) !== -1;
			const typeOK = !filter.types || filter.types.indexOf(type) !== -1;

			if (sourceOK && typeOK) {
				return filter.layerId;
			}
		}

		return null;
	}

	/**
	 * Otestuje marker.
	 *
	 * @param  {Number|String} id ID markeru
	 * @param  {Number|String} layerId ID vrstvy
	 * @return {Boolean}
	 */
	_checkMarker(id, layerId) {
		const oldMarkers = this._oldMarkers[layerId] || [];

		for (let index = 0; index < oldMarkers.length; index++) {
			const oldMarker = oldMarkers[index];

			if (oldMarker.getId() === id) {
				oldMarkers.splice(index, 1);

				return true;
			}
		}

		return false;
	}
}
